module.exports = {
    "baseUrl": "https://api-v4.primrose.health",
    "baseUrl2": "https://api.primrose.health",
    "dashboardUrl": "https://claimupload.primrose.health",
    "systemName": "System Prod",
    "chatServer": "https://staging.trillium.health:8082/chatWebsocket",
    "videoServer": "https://production.trillium.health:9090/schedularWebsocket",
    "newChatServer": "https://api-v4.chat.primrose.health",
    "prodStatus": false,
    "patientChatUrl": "https://m.primrose.health",
    "stripeKey": "pk_live_51Ia02yIg43ZjHHGkZRwf5Ap3qTBlvEKJIe08edJWqyVDlEs30E8wHlnWl8XWqfzlEufmqMwattqTzzojGlDc6Sul00stDc8rJm",
    "companyTitle": "Clinic Scheduler | Trillium Health",
    "metaTitle": "Trillium Health Scheduler Web App",
    "metaDescription": "Scheduler for physicians and clinics from Trillium Health",
    "favicon": "%PUBLIC_URL%/favicon.primrose.png",
    "companyName": "Trillium Technologies",
    "copyRight": "Primrose Health and Trillium Technologies are trademarks of their respective owners.",
    "companyKey": "trillium",
    "aboutHref": "#0",
    "contactHref": "#0",
    "selfPayApi": "https://app.primrose.health"
}